import React from "react";
import { useState } from "react";
import useKeysQuestion from "../hooks/useKeysQuestion";

interface KeysQuestionProps {
  question: Question;
}

export const KeysQuestion = ({ question }: KeysQuestionProps) => {
  const { error, handleChange, storedAnswer, sortedAnswers } = useKeysQuestion({
    question
  });
  const [selectedOption, setSelectedOption] = useState(storedAnswer);

  const inputs = sortedAnswers.map((answerObject: any) => {
    return (
      <div className="ch-mb--3" key={answerObject.id}>
        <input
          id={`${answerObject.label}`}
          type="radio"
          name={`service-option`}
          className="ch-radio"
          checked={
            selectedOption ? selectedOption[0] === answerObject.id : false
          }
          onChange={() => {
            handleChange(parseInt(answerObject.id));
            setSelectedOption([answerObject.id]);
          }}
        />
        <label
          htmlFor={`${answerObject.label}`}
          className="ch-radio__label ch-radio__label--primary"
        >
          {answerObject.label}
        </label>
      </div>
    );
  });
  return (
    <div className="ch-form__group ch-flex-flow--column-nowrap">
      {error === "radio" && (
        <div className="ch-form__group ch-form__group--error ch-mb--0">
          <span className="ch-form__control-validation ch-mb--1">
            Please choose an option
          </span>
        </div>
      )}
      {inputs}
    </div>
  );
};
